import { ArchivalCollection, ResearchSheet, User, NewOrder } from 'types';

export const getArchivalCollectionOrderDetails = (
  archivalCollection: ArchivalCollection,
  userInfo: User,
  userSheet?: ResearchSheet
) => {
  if (userSheet?.id) {
    const { owner, id, type } = userSheet ?? {};

    const firstName = owner?.firstName;
    const lastName = owner?.lastName;

    const fullName = [firstName, lastName].filter((s) => !!s).join(' ');

    return {
      phone: owner?.phone,
      fullName,
      researchSheet: {
        id,
        type,
      },
      archivalCollection,
    } as NewOrder;
  } else {
    const {
      currentlyUsedSheetId,
      currentlyUsedSheetType,
      firstName,
      lastName,
      phone,
    } = userInfo ?? {};

    const fullName = [firstName, lastName].filter((s) => !!s).join(' ');
    return {
      phone,
      fullName,
      researchSheet: {
        id: currentlyUsedSheetId!,
        type: currentlyUsedSheetType!,
      },
      archivalCollection,
    } as NewOrder;
  }
};

export const getArchivalAidOrderDetails = (
  archivalAidMetadata: ArchivalCollection,
  userInfo: User,
  userSheet?: ResearchSheet
) => {
  if (userSheet?.id) {
    const { owner, id, type } = userSheet ?? {};

    const firstName = owner?.firstName;
    const lastName = owner?.lastName;

    const fullName = [firstName, lastName].filter((s) => !!s).join(' ');

    return {
      phone: owner?.phone,
      fullName,
      researchSheet: {
        id,
        type,
      },
      archivalAidMetadata,
    } as NewOrder;
  } else {
    const {
      currentlyUsedSheetId,
      currentlyUsedSheetType,
      firstName,
      lastName,
      phone,
    } = userInfo ?? {};

    const fullName = [firstName, lastName].filter((s) => !!s).join(' ');
    return {
      phone,
      fullName,
      researchSheet: {
        id: currentlyUsedSheetId!,
        type: currentlyUsedSheetType!,
      },
      archivalAidMetadata,
    } as NewOrder;
  }
};
